// 모든 편집 화면의 저장 진입점에서 재사용한다. 비동기 이미지 업로드가 끝나기 전에
// 본문을 저장하여 이미지가 빠지는 일을 방지하며, API를 자동 재호출하지 않는다.
export function editorsReady (component) {
  const pending = []
  function visit (current) {
    if (current.$options.name === 'CustomTextarea' && current.uploading > 0) pending.push(current)
    current.$children.forEach(visit)
  }
  visit(component)
  pending.forEach(editor => { editor.error = '이미지 업로드가 끝난 뒤 다시 저장해 주세요.' })
  if (pending.length) pending[0].$el.scrollIntoView({ block: 'center', behavior: 'smooth' })
  return pending.length === 0
}



// WEBPACK FOOTER //
// ./src/components/ETC/editor/form.js